import { atom } from 'recoil'

import type { SelectFiltersState } from './model'

export const filtersState = atom<SelectFiltersState>({
  key: 'useSelectFilters_filtersState',
  default: {
    options: [],
    optionsGroups: [],
    status: 'initial',
    loading: false,
  },
})
